import type { Conversation } from '@/types/andrzej'

interface Props {
  conversations: Conversation[]
  activeId: number | null
  onSelect: (id: number) => void
}

export function ConversationList({ conversations, activeId, onSelect }: Props) {
  if (conversations.length === 0) {
    return (
      <p className="px-3 py-2 text-xs text-frame">Brak rozmów</p>
    )
  }

  return (
    <div className="space-y-0.5 p-1">
      {conversations.map(c => (
        <button
          key={c.id}
          onClick={() => onSelect(c.id)}
          className={`block w-full rounded px-2 py-1.5 text-left text-xs transition-colors ${
            c.id === activeId
              ? 'bg-botanical-light text-botanical'
              : 'hover:bg-paper-dark text-ink-light'
          }`}
        >
          <div className="font-medium truncate">
            {c.plant_name || c.title || c.context}
          </div>
          <div className="text-frame truncate">
            {c.updated_at}{c.last_message ? ` · ${c.last_message}` : ''}
          </div>
        </button>
      ))}
    </div>
  )
}
